import React, { useState } from 'react'
import styles from './CompanyName.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { FormField } from '../../../Common/FormField'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

export const CompanyName = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const [companyName, setCompanyName] = useState('')
    const [brandName, setBrandName] = useState('')
    const [storeName, setStoreName] = useState('')

    const isFormValid = companyName.trim() !== '' && brandName.trim() !== ''

    const handleCompanyNameChange = (value: string) => {
        setCompanyName(value)
    }

    const handleBrandNameChange = (value: string) => {
        setBrandName(value)
    }

    const handleStoreNameChange = (value: string) => {
        setStoreName(value)
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='直近の会社名・店舗名は？'
                        dataViewLabel={dataViewLabel('EF_StepForm_直近の会社')}
                        dataClickLabel={dataClickLabel('EF_StepForm_直近の会社-戻る')}
                    />
                </div>
                <div className={styles.companyFields}>
                    <div className={styles.fieldWrapper}>
                        <div className={styles.labelWithBadge}>
                            <span className={styles.label}>会社名</span>
                            <span className={styles.requiredBadge}>必須</span>
                        </div>
                        <FormField
                            label=''
                            placeholder=' (例) 株式会社フーズラボ'
                            value={companyName}
                            onChange={handleCompanyNameChange}
                        />
                    </div>

                    <div className={styles.fieldWrapper}>
                        <div className={styles.labelWithBadge}>
                            <span className={styles.label}>ブランド・系列名</span>
                            <span className={styles.requiredBadge}>必須</span>
                        </div>
                        <FormField
                            label=''
                            placeholder=' (例) フーズラボバーガー'
                            value={brandName}
                            onChange={handleBrandNameChange}
                        />
                    </div>

                    <div className={styles.fieldWrapper}>
                        <div className={styles.labelWithBadge}>
                            <span className={styles.label}>店舗名</span>
                        </div>
                        <FormField
                            label=''
                            placeholder=' (例) 渋谷店'
                            value={storeName}
                            onChange={handleStoreNameChange}
                        />
                    </div>

                    <img
                        src="/foodslaboEf/img/step9/warning-note.png"
                        alt="注意事項"
                        className={styles.warningImage}
                    />
                </div>
                <NextButton
                    formKey={['userResumesAttributes', 'companyName', 'brandName', 'storeName']}
                    formValue={[0, companyName, brandName, storeName]}
                    displayFormKey={['companyName', 'brandName', 'storeName']}
                    displayFormValue={[companyName, brandName, storeName]}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_直近の会社-次へ')}
                />
            </div>
        </div>
    )
}
